import React, { Component } from 'react'
import '../styles/CreateUserForm.css'
import DropdownWidget from '../widgets/DropdownWidget'
import APIGenericRequest from '../api/APIGenericRequest'
import APIUserAccountRequest from '../api/APIUserAccountRequest'
import xButton from '../images/x.png'
import ActivityIndicator from '../widgets/ActivityIndicator'
import AlertMessage from '../widgets/AlertMessage'

class CreateUserForm extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			region: "REGION",
			province: "PROVINCE",
			role: "-- SELECT --",
			extName: "EXT",
		}
		this.getAllRegions = this.getAllRegions.bind(this)
		this.getAllProvincesByRegionId = this.getAllProvincesByRegionId.bind(this)
		this.getAllUserRoles = this.getAllUserRoles.bind(this)
		this.submitUserForm = this.submitUserForm.bind(this)
	}

	componentWillMount() {
		this.getAllRegions()
		this.getAllUserRoles()
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken);
		ext.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name});
			}
			c.push({id: 0, name: "N/A"});
			this.setState({extNames: c});
		});
	}

	getAllRegions() {
		const region = APIGenericRequest.getAllRegions(this.state.accessToken)
		region.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.region_id, name: v.name.split("[")[0]})
			}
			c.push({id: 0, name: "-- SELECT REGION --"})
			this.setState({regions: c})
		})
	}

	getAllProvincesByRegionId(id) {
		const province = APIGenericRequest.getAllProvincesByRegionId(this.state.accessToken, id)
		province.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.province_id, name: v.name})
			}
			c.push({id: 0, name: "-- SELECT PROVINCE --"})
			this.setState({provinces: c, province: "PROVINCE"})
		})
	}

	getAllUserRoles() {
		const role = APIUserAccountRequest.getAllUserRoles(this.state.accessToken)
		role.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.role_id, name: v.name})
			}
			this.setState({roles: c})
		})
	}

	submitUserForm(data) {
		const sur = APIUserAccountRequest.submitUserRegistration(this.state.accessToken, data)
		sur.then((response) => {
			this.setState({showActivityIndicator: false})
			if (response.status !== "SUCCESS") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			this.props.onSignal("submit")
		})
	}

	render() {
		const view = <div className="create-user">
			<div className="cu-header">
				<div>CREATE USER FORM</div>
				<img src={xButton} className="close-icon" alt="ADD" onClick={() => {
					this.props.onSignal("cancel")
				}} />
			</div>
			<div className="cu-body">
				<div className="cu-fullname">
					<div>Full Name</div>
					<input type="text" id="cu-firstname" placeholder="FIRST NAME"
						onChange={e => this.setState({firstName: e.target.value}) } />
					<input type="text" id="cu-middlename" placeholder="MIDDLE NAME"
						onChange={e => this.setState({middleName: e.target.value}) } />
					<div>
						<input type="text" id="cu-lastname" placeholder="LAST NAME"
						onChange={e => this.setState({lastName: e.target.value}) } />
						<DropdownWidget list={this.state.extNames} placeholder={this.state.extName}
						onItemSelected={(id, val) => {
							this.setState({extName: val})
						}} cStyle={{"width": "60px"}} />
					</div>
				</div>
				<div className="cu-address">
					<div>Office Address</div>
					<DropdownWidget list={this.state.regions} placeholder={this.state.region}
						cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
							this.getAllProvincesByRegionId(id)
							this.setState({regionId: id})
						}} />
					<DropdownWidget list={this.state.provinces} placeholder={this.state.province}
						cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
							this.setState({provinceId: id})
						}} />
				</div>
				<div className="cu-role">
					<div>Role</div>
					<DropdownWidget list={this.state.roles} placeholder={this.state.role}
						cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
							this.setState({roleId: id})
						}} />
				</div>
				<div className="cu-contact">
					<div>Contact No.</div>
					<input type="text" value={this.state.contactNo} onChange={(e) => {
						const checker = /^[0-9]+$/
						const isValid = checker.test(e.target.value)
						if(isValid) {
							this.setState({contactNo: e.target.value})
						}
						else {
							if(isNaN(parseInt(e.target.value))) {
								this.setState({contactNo: null})
								e.target.value = ""
							}
							else {
								e.target.value = parseInt(e.target.value)
							}
						}
					}} maxLength="11" />
				</div>
				<div className="cu-login">
					<div>Login Credentials</div>
					<input type="text" id="cu-username" placeholder="Username" onChange={e => {
						const checker = /^[A-Za-z0-9@._-]+$/
						const isValid = checker.test(e.target.value)
						if(isValid) {
							this.setState({username: e.target.value})
						}
						else {
							this.setState({username: null})
						}
					}} style={{'text-transform': 'none'}} />
					<input type="text" id="cu-password" placeholder="Password"
						onChange={e => this.setState({password: e.target.value}) }
						style={{'text-transform': 'none'}} />
				</div>
				<button className="green-two" onClick={() => {
					this.setState({showActivityIndicator: true})
					const data = {
						"employeeBasicInfo": {
							"last_name": this.state.lastName,
							"first_name": this.state.firstName,
							"extension_name": (this.state.extName === "EXT" || this.state.extName === "N/A")? null: this.state.extName,
							"middle_name": this.state.middleName,
							"contact_no": this.state.contactNo
						},
						"userDetails": {
							"username": this.state.username,
							"password": this.state.password,
							"role_id": this.state.roleId,
							"region_id": this.state.regionId,
							"province_id": this.state.provinceId,
							"user_status_id": 1
						}
					}
					this.submitUserForm(data)
				}}>SUBMIT</button>
			</div>
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

export default CreateUserForm
